/*
 * @Author: xiaoguanghua
 * @Date: 2025-01-06
 * @LastEditTime
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [{
  path: '*',
  redirect: '/cloudSpeedup'
},
{
  name: 'cloudSpeedup',
  component: () => import('./view/welkin/cloudSpeedup'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'handCart',
  component: () => import('./view/welkin/handCart'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'handCart1',
  component: () => import('./view/welkin/handCart'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'ironPan',
  component: () => import('./view/welkin/ironPan'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'zhumian',
  component: () => import('./view/welkin/zhumian'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'cloudSpeedupCopy',
  component: () => import('./view/welkin/cloudSpeedupCopy'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'orderResult',
  component: () => import('./view/welkin/orderResult'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'course',
  component: () => import('./view/welkin/course'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'course2',
  component: () => import('./view/welkin/course2'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'course3',
  component: () => import('./view/welkin/course3'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'courseDst3',
  component: () => import('./view/welkin/courseDst3'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'courseDst2',
  component: () => import('./view/welkin/courseDst2'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'radio',
  component: () => import('./view/welkin/radio'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xueya',
  component: () => import('./view/welkin/xueya'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xueyayi',
  component: () => import('./view/welkin/xueyayi'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xuetangyi',
  component: () => import('./view/welkin/xuetangyi'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningxuetangyi',
  component: () => import('./view/welkin/shuningxuetangyi'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xuetangtie',
  component: () => import('./view/welkin/xuetangtie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningxuetangtie',
  component: () => import('./view/welkin/shuningxuetangtie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'qianliexian',
  component: () => import('./view/welkin/qianliexian'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningqianliexian',
  component: () => import('./view/welkin/shuningqianliexian'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xueyayinew',
  component: () => import('./view/welkin/xueyayinew'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'xueyayi3',
  component: () => import('./view/welkin/xueyayi3'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'dianfanbao',
  component: () => import('./view/welkin/dianfanbao'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'bingcheng',
  component: () => import('./view/welkin/bingcheng'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'jianbuxie',
  component: () => import('./view/welkin/jianbuxie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'pobiji',
  component: () => import('./view/welkin/pobiji'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'maziyou',
  component: () => import('./view/welkin/maziyou'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'jianbuxie2',
  component: () => import('./view/welkin/jianbuxie2'),
  meta: {
    title: '立即领取课程'
  }
},

{
  name: 'aicaozhen',
  component: () => import('./view/welkin/aicaozhen'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'tuonai',
  component: () => import('./view/welkin/tuonai'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'yinwan',
  component: () => import('./view/welkin/yinwan'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'ciliaotie',
  component: () => import('./view/welkin/ciliaotie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningciliaotie',
  component: () => import('./view/welkin/shuningciliaotie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningyantie',
  component: () => import('./view/welkin/shuningyantie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningxueyatie',
  component: () => import('./view/welkin/shuningxueyatie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningshiniantie',
  component: () => import('./view/welkin/shuningshiniantie'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'vivoxueyaji',
  component: () => import('./view/welkin/vivoxueyaji'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'rongyaoxueyaji',
  component: () => import('./view/welkin/rongyaoxueyaji'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'shuningxueyaji',
  component: () => import('./view/welkin/shuningxueyaji'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'yinwan2',
  component: () => import('./view/welkin/yinwan2'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'yinwan3',
  component: () => import('./view/welkin/yinwan3'),
  meta: {
    title: '立即领取课程'
  }
},
{
  name: 'yinwan10shuning',
  component: () => import('./view/welkin/yinwan10'),
  meta: {
    title: '立即领取课程'
  }
},
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
  mode: 'hash',
  routes
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};